import { useEffect } from 'react';

import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import { App as AntdApp } from 'antd';
import { getErrorMessage } from 'utils/helpers/getErrorMessage';

interface Props {
  status: QueryStatus;
  error: any;
  data?: any;
  successMessage?: string;
  errorMessage?: string;
  onSuccess?: VoidFunction;
  onError?: VoidFunction;
}

const key = Date.now();

export const useMessageLogger = ({
  error,
  data,
  onError,
  onSuccess,
  successMessage,
  errorMessage,
  status,
}: Props) => {
  const { message } = AntdApp.useApp();

  useEffect(() => {
    if (status === QueryStatus.pending) {
      message.loading({ content: 'Отправка запроса на сервер...', key, duration: 0 });
    } else if (status === QueryStatus.rejected) {
      message.error({ content: errorMessage ? errorMessage : getErrorMessage(error), key });
      onError && onError();
    } else if (status === QueryStatus.fulfilled) {
      if (data && data.success === false) {
        const errorObj = {
          data: {
            error: data.error,
            code: data.status,
            message: data.error,
          },
        };
        message.error({ content: errorMessage ? errorMessage : getErrorMessage(errorObj), key });
        onError && onError();
      } else {
        if (successMessage) {
          message.success({ content: successMessage, key });
        } else {
          setTimeout(() => message.destroy(key), 400);
        }
        onSuccess && onSuccess();
      }
    }
  }, [status]);
};
